import React from 'react';
import "./style.scss"

function Loader2({text = 'در حال بارگزاری'}) {
  return (<div>
    <div className="three-body">
      <div className="three-body__dot"></div>
      <div className="three-body__dot"></div>
      <div className="three-body__dot"></div>
    </div>
    <div>{text}</div>
  </div>);
}

export default Loader2;